import React from 'react';

const MarketingInfoPage = ({ title, eyebrow, description, highlights = [], primaryAction, secondaryAction }) => (
  <div className="bg-[#f6f8fc] py-12 px-4">
    <div className="max-w-6xl mx-auto space-y-8">
      <section className="rounded-[32px] bg-gradient-to-r from-slate-950 via-slate-900 to-blue-950 text-white p-8 md:p-12">
        <p className="text-sm uppercase tracking-[0.24em] text-cyan-200 mb-4">{eyebrow}</p>
        <h1 className="text-4xl md:text-5xl font-semibold max-w-3xl leading-tight">{title}</h1>
        <p className="mt-4 text-slate-300 max-w-2xl text-base md:text-lg">{description}</p>

        <div className="mt-8 flex flex-wrap gap-3">
          {primaryAction && (
            <button
              onClick={primaryAction.onClick}
              className="px-5 py-3 rounded-2xl bg-cyan-400 text-slate-950 font-semibold hover:bg-cyan-300"
            >
              {primaryAction.label}
            </button>
          )}
          {secondaryAction && (
            <button
              onClick={secondaryAction.onClick}
              className="px-5 py-3 rounded-2xl border border-white/20 text-white hover:bg-white/10"
            >
              {secondaryAction.label}
            </button>
          )}
        </div>
      </section>

      <section className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {highlights.map((item) => (
          <div key={item.title} className="rounded-3xl bg-white border border-slate-100 shadow-sm p-6">
            <div className="w-12 h-12 rounded-2xl bg-slate-950 text-white flex items-center justify-center text-lg font-semibold mb-4">
              {item.badge}
            </div>
            <h2 className="text-xl font-semibold text-slate-900">{item.title}</h2>
            <p className="mt-3 text-slate-600">{item.description}</p>
          </div>
        ))}
      </section>
    </div>
  </div>
);

export default MarketingInfoPage;
